import daugther from "../assets/images/daughter.png";
import mother from "../assets/images/mother.png";
import son from "../assets/images/son.png";

export const avatarDetails: Record<
  string,
  { urlImage: string; title: string }
> = {
  mother: {
    urlImage: mother,
    title: "كفالة أرملة",
  },
  daughter: {
    urlImage: daugther,
    title: "كفالة يتيمة",
  },
  son: {
    urlImage: son,
    title: "كفالة يتيم",
  },
};

export const options = [
  { id: "widow", name: "أرملة" },
  { id: 2, name: "يتيم(ة)" },
  { id: 3, name: "الإثنين معاً" },
];
